import PageTemplate from "../pageTemplate";

export default function Examples() {
    return (
        <PageTemplate>
            <h1>Examples</h1>
            <p>Some information about the examples</p>
        </PageTemplate>
    )
}